import React from "react";
import { Link as ScrollLink } from "react-scroll";

function Portfolio({ portfolio: { id, name, category, image, slug } }) {
  return (
    <ScrollLink
      to="section-portfolios"
      spy={true}
      smooth={true}
      offset={-50}
      duration={500}
    >
      <div className="portfolio-item">
        <div className="details">
          <h4 className="title">{name}</h4>
          <span className="term">{category.join(",  ")}</span>
        </div>
        {/* <span className="plus-icon">+</span> */}
        <div className="thumb">
          <img src={image} alt={name} />
          <div className="mask"></div>
        </div>
      </div>
    </ScrollLink>
  );
}

export default Portfolio;
